export const EMPLOYEE_COLUMNS_HEADER_HEIGHT = 75;
export const ONE_MINUTE = 60000;
